module.exports = __webpack_public_path__ + "static/img/5636_phase_function_Paper_PointsHejduk_Prediction.4d2be5f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/5636_phase_function_Paper_PointsHejduk_Prediction.png
// module id = BU2e
// module chunks = 0